import { Solicitud } from '../../../../classes/Solicitud';
import Accordion from '../../../../components/Accordion';
import { useEffect, useState } from 'react';
import { useSolicitud } from '../../../../hooks/useSolicitud';
import Table, {
  ColumnDefinitionType,
} from '../../../../components/Table';
import { Loading } from '../../../../components/Loading';
import moment from 'moment';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../app/store';
import { downloadAndOpenQR } from '../../../../services/Service';
import { useSolicitudPermissions } from '../../../../hooks/useSolicitudPermissions';

// Componente separado para manejar los permisos de cada fila
const ActionCell = ({
  data,
  permisos,
  handleUrlVolver,
}: {
  data: Solicitud;
  permisos: string[];
  handleUrlVolver: (url: string) => void;
}) => {
  // Usar el hook unificado de permisos
  const { canEditWithProfiles } = useSolicitudPermissions({
    solicitudEstadoId: data.idTipoEstado,
  });

  const puedeEditar = canEditWithProfiles;

  return (
    <>
      {permisos.find((nombre) => nombre === 'VISTA_SOLICITUD') !==
        undefined && (
        <Link
          to={`/solicitud/${data.id}?action=view`}
          title="Visualizar"
          onClick={(e) => {
            e.stopPropagation();
            handleUrlVolver('/consultaSolicitudes');
          }}
        >
          <i
            className="fa fa-eye text-secondary me-2"
            aria-hidden="true"
          ></i>
        </Link>
      )}
      {puedeEditar &&
        permisos.find((nombre) => nombre === 'EDICION_SOLICITUD') !==
          undefined && (
          <Link
            to={`/solicitud/${data.id}?action=edit`}
            title="Editar"
            onClick={(e) => {
              e.stopPropagation();
              handleUrlVolver('/consultaSolicitudes');
            }}
          >
            <i
              className="fa fa-pencil text-secondary"
              aria-hidden="true"
            ></i>
          </Link>
        )}
      {permisos.find((nombre) => nombre === 'CONSULTA_SOLICITUD') !==
        undefined && (
        <Link
          to={'#'}
          title="QR"
          onClick={(e) => {
            e.stopPropagation();
            downloadAndOpenQR(`/solicitudes/${data.id}/QRCode`);
          }}
        >
          <i
            className="fa fa-qrcode fa-lg mx-1 text-success"
            aria-hidden="true"
          ></i>
        </Link>
      )}
    </>
  );
};

export const TablaSolicitud = () => {
  const { permisos } = useSelector((state: RootState) => state.auth);
  const {
    solicitudes,
    buscarSolicitudes,
    handleLoading,
    loading,
    handleUrlVolver,
  } = useSolicitud();
  const [secondaryButton] = useState(
    permisos.find((nombre) => nombre === 'ALTA_SOLICITUD') !==
      undefined
  );

  const [filtroSolicitudIni] = useState<any>({
    numeroSolicitud: '',
    numeroContrato: '',
    idTipoTrabajo: '',
    idTipoEstado: '',
    idEmpresaGestora: '',
    idContratista: '',
    fechaInicio: '',
    fechaFin: '',
  });

  useEffect(() => {
    handleLoading(true);
    buscarSolicitudes(filtroSolicitudIni);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtroSolicitudIni]);

  let columns: ColumnDefinitionType<Solicitud, keyof Solicitud>[] = [
    {
      key: 'numeroSolicitud',
      header: 'Número de Solicitud',
    },
    {
      key: 'instalacion',
      header: 'Instalación',
      cell: (data: Solicitud) => <>{data.instalacion ?? ''}</>,
    },
    {
      key: 'tipoTrabajo',
      header: 'Tipo de Trabajo',
    },
    {
      key: 'fechaInicio',
      header: 'Fecha Inicio',
      cell: (data: Solicitud) => (
        <>
          {data.fechaInicio
            ? moment(data.fechaInicio).format('DD/MM/YYYY')
            : ''}
        </>
      ),
    },
    {
      key: 'fechaFin',
      header: 'Fecha Fin',
      cell: (data: Solicitud) => (
        <>
          {data.fechaFin
            ? moment(data.fechaFin).format('DD/MM/YYYY')
            : ''}
        </>
      ),
    },
    {
      key: 'estado',
      header: 'Estado',
    },

    {
      key: 'empresaGestora',
      header: 'Empresa Gestora',
    },
    {
      key: 'contratista',
      header: 'Contratista',
    },

    {
      key: 'id',
      header: 'Acciones',
      cell: (data: Solicitud) => (
        <ActionCell
          data={data}
          permisos={permisos}
          handleUrlVolver={handleUrlVolver}
        />
      ),
    },
  ];
  if (
    permisos.find((nombre) => nombre === 'VISTA_SOLICITUD') ===
      undefined &&
    permisos.find((nombre) => nombre === 'EDICION_SOLICITUD') ===
      undefined
  ) {
    columns = columns.filter((c) => c.key !== 'id');
  }
  const navigate = useNavigate();

  const handleSecondary = () => {
    // setIsOpen(true);
    navigate('/crearSolicitud');
  };

  return (
    <>
      <Accordion
        id={'accordionSolicitudListado'}
        title="Listado de Solicitudes"
        secondary={secondaryButton}
        titleSecondary="Crear Solicitud"
        iconoClass="fa fa-search mr-1"
        handleSecondary={handleSecondary}
        link="/crearSolicitud"
      >
        <div className="table-responsive ">
          {loading ? (
            <Loading />
          ) : (
            solicitudes && (
              <Table
                data={solicitudes || []}
                columns={columns}
                notResults="No existen solicitudes para el criterio ingresado"
              ></Table>
            )
          )}
        </div>
      </Accordion>
    </>
  );
};
